import React, { useRef, useState, useEffect } from 'react';
import Typography from "@mui/material/Typography";

const OTPInputGroup = ({ handleNextButton, setOtpLoading, setPrintMsg, printMsg }) => {
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const [otpValues, setOtpValues] = useState(Array(4).fill(''));

  // Auto-focus the first input on mount
  useEffect(() => {
    inputRefs[0].current?.focus();
  }, []);

  const handleInputChange = (index, value) => {
    // Allow clearing
    if (value === '') {
      const newOtpValues = [...otpValues];
      newOtpValues[index] = '';
      setOtpValues(newOtpValues);
      return;
    }

    // Allow only single digit numbers
    if (!/^[0-9]$/.test(value)) return;

    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);
    setPrintMsg(null);

    // Move to next input if current input is filled
    if (index < inputRefs.length - 1) {
      inputRefs[index + 1].current?.focus();
    }

    // If all fields are filled, trigger submit
    if (newOtpValues.every((val) => /^[0-9]$/.test(val))) {
      handleSubmit(newOtpValues);
    }
  };


  // Handle key events (Backspace, Arrow Navigation)
  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otpValues[index] && index > 0) {
      inputRefs[index - 1].current?.focus();
    } else if (e.key === 'ArrowLeft' && index > 0) {
      inputRefs[index - 1].current?.focus();
    } else if (e.key === 'ArrowRight' && index < inputRefs.length - 1) {
      inputRefs[index + 1].current?.focus();
    }

    // Prevent entering non-numeric characters, including 'e', '+', and '-'
    if (['e', 'E', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }
  };

  // Handle OTP submission
  const handleSubmit = (otpArray) => {
    const wholeOtp = otpArray.join('');
    if (wholeOtp.length === 4) {
      handleNextButton(wholeOtp);
      setOtpLoading?.(true);
      setPrintMsg(null);
    }
  };

  return (
    <div>
      <div id="OTPInputGroup" className="digitGroup" data-autosubmit="true">
        {otpValues.map((value, index) => (
          <input
            key={index}
            ref={inputRefs[index]}
            type="number"
            className="DigitInput"
            value={value}
            maxLength="1"
            inputMode="numeric" // Enables numeric keypad on mobile devices
            pattern="[0-9]*" // Suggests a numeric-only keyboard
            onChange={(e) => handleInputChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={(e) => e.preventDefault()} // Prevent pasting multiple values
          />
        ))}
      </div>

      {printMsg !== null && (
        <Typography
          variant='body2'
          sx={{ textAlign: 'center', color: printMsg !== '11' ? 'red' : 'green' }}
        >
          {printMsg !== '11' ? printMsg : 'OTP has been sent'}
        </Typography>
      )}
    </div>
  );
};

export default OTPInputGroup;
